/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Ai_Format_HtmlInputs */

const cs_templates_ai_format_html = /** @type {(inputs: Templates_Ai_Format_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HTML`)
};

const en_templates_ai_format_html = /** @type {(inputs: Templates_Ai_Format_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HTML`)
};

/**
* | output |
* | --- |
* | "HTML" |
*
* @param {Templates_Ai_Format_HtmlInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_ai_format_html = /** @type {((inputs?: Templates_Ai_Format_HtmlInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Ai_Format_HtmlInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_ai_format_html(inputs)
	return cs_templates_ai_format_html(inputs)
});